<woa-modal-page-layout [title]="title()"
                       [translationParams]="{'itemName': orderItem().nameSignal()}">
    @if (orderItem().availableExtraGroups().length) {
        <woa-order-item-extras-edit-panel [orderItem]="orderItem()"
                                          [mainOrderItem]="mainOrderItem()"
                                          [originalOrderItem]="originalOrderItem()"
                                          [allowInitialState]="true"
                                          [menuItem]="menuItem()"
                                          [promotedExtraGroup]="promotedExtraGroup()"
                                          [showOnlyCombinedExtras]="!promotedExtraGroup()"
                                          (onChange)="changesMade = true"></woa-order-item-extras-edit-panel>
    }
    @if (promotedExtraGroup()) {
        <woa-button woa-page-footer-control [label]="'woa.button.common.noThanks'"
                    [prominence]="ButtonProminence.LOW"
                    (onActivate)="dismiss(false)"></woa-button>
    }
    <woa-button woa-page-footer-control [label]="'woa.button.order.confirmChanges'"
                (onActivate)="dismiss(changesMade)"></woa-button>
</woa-modal-page-layout>
